//  三方商品管理
import utils from '../libs/utils';
import axios from './axios';

const baseUrl = 'v1/erp-business-web';

export default {
  axios,
  getThirdPartyList(params) { // 三方商品管理List
    return axios.post(`${baseUrl}/tmall/sku/listByQo`, params);
  },
  getThirdPartyInfo(params) { // 详情
    return axios.get(`${baseUrl}/tmall/sku/info?${utils.exchangeParams(params)}`);
  },
  getGoodsInfo(params) { // 查询商品
    return axios.get(`${baseUrl}/tmall/sku/getGoodsInfo?${utils.exchangeParams(params)}`);
  },
  thirdPartySubmit(params) { // 提交
    return axios.post(`${baseUrl}/tmall/sku/add`, params);
  },
  thirdPartyEdit(params) { // 编辑提交
    return axios.post(`${baseUrl}/tmall/sku/edit`, params);
  },
  deleteThirdPartyGoods(params) { // 删除
    return axios.post(`${baseUrl}/tmall/sku/delete?${utils.exchangeParams(params)}`);
  },
};
